<template>
    <section id="checkout">
        <div id="breadcrumbs">
            <div class="bg-light py-3">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="alert alert-warning">
                                Compras superiores a $599.00 no genera costo de envío (No aplica
                                suscripciones)
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 mb-0 text-left">
                            <router-link to="/">Home</router-link>
                            <span class="mx-2 mb-0">/</span>
                            <router-link to="/cart">Carrito</router-link>
                            <span class="mx-2 mb-0">/</span>
                            <strong class="text-black">Pago</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- #breadcrumbs -->
        <div class="site-section">
            <div class="container">
                <div class="row" >
                    <div class="col-12 col-sm-7 order-last order-sm-first">
                        <GuestForm @changeV="changeView" @update="updateAddress" @updateUser="updateUser" v-show="!is_registered"></GuestForm>
                        <address-card :address-data="addressData" v-if="is_registered"></address-card>
                        <payment-methods v-bind:products="products" :address="addressData" :user-data="userData" @statusLoader="onListenerLoader" v-if="is_registered"></payment-methods>
                    </div>
                    <div class="col-12 col-sm-5 order-first order-sm-last">
                        <div class="card">
                            <div class="card-body">
                                <products-list></products-list>
                            </div><!-- .card-body -->
                        </div><!-- .card -->
                    </div>
                </div><!-- .row -->
                <!-- <div v-if="is_registered" class="row">
                    <div class="col-md-6 offset-lg-3">
                        <div class="row mb-5" v-show="false">
                            <div class="col-md-12">
                                <h2 class="h3 mb-3 text-black mt-3">Coupon Code</h2>
                                <div class="p-3 p-lg-5 border">
                                    <label for="c_code" class="text-black mb-3">Ingresa tu cup&oacute;n sii tienes uno</label>
                                    <div class="input-group w-75">
                                        <input type="text" class="form-control" id="c_code" placeholder="Código del cupon" aria-label="Coupon Code" aria-describedby="button-addon2"/>
                                        <div class="input-group-append">
                                            <button class="btn btn-primary btn-sm" type="button" id="button-addon2">
                                                Aplicar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>.row -->
            </div> <!-- .container -->
        </div> <!-- .site-section -->
        <loading :active.sync="is_loading"></loading>
    </section>
</template>

<script>
// @ is an alias to /src
//import axios from "axios"
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import GuestForm from "@/components/User/GuestForm.vue";
import ProductsList from "@/components/Products/ProductCheckoutList.vue";
import PaymentMethods from "@/components/Payment/PaymentMethods";
import AddressCard from "@/components/Address/AddressCard";
import AddressForm from "@/components/AddressForm.vue";
const axios = require("axios");

export default {
    name: "GuestCheckout",
    components: {
        Loading,
        AddressForm,
        GuestForm,
        ProductsList,
        PaymentMethods,
        AddressCard
    },
    data() {
        return {
            is_loading: false,
            api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
            base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
            local_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE,
            is_registered: false,
            userData: {},
            products: [],
            addressData: {},
            showTotal: false,
        };
    },
    created() {
        const script = document.createElement("script");
        script.src = "https://cdn.conekta.io/js/latest/conekta.js";
        script.async = true;
        document.body.appendChild(script);

        // Se verifica si el usuario esta logeado

        this.products = this.$store.state.cart;
        this.checkIsRegistered();

    },
    watch: {
        is_registered: function(newVal, oldVal){
            if (newVal){
                window.dataLayer.push({
                    'event': 'checkout',
                    'pageURL': this.$router.currentRoute.fullPath,
                    'product': this.products,
                });
            }
        }
    },
    methods: {
        checkIsRegistered: function(){
            if ($cookies.get('uidmmkg') && $cookies.get('utoken') && this.addressData.id !== undefined){
                this.is_registered = true;
            }
        },
        changeView: function (value) {
            console.info('Accediendo a la Informacion de Pago');
            window.dataLayer.push({
                'event': 'AgregandoInfodePago',
                'pageURL': this.$router.currentRoute.fullPath,
                'product': this.products,
            });
            this.showTotal = value;
        },
        getdirections() {
            axios.get(this.url).then((data) => {
                this.directions = data.data;
            });
        },
        onListenerLoader:  function(value){
            console.info(value);
            this.is_loading = value;
        },
        updateAddress: function (value) {
            console.info("Actualizando direccion en Checkout");
            console.info(value);
            this.addressData = value;
            this.checkIsRegistered();
            window.dataLayer.push({
                'event': 'AgregandoInfodePago',
                'pageURL': this.$router.currentRoute.fullPath,
                'product': this.products,
            });
        },
        updateUser: function(data){
            this.userData = data;
        },
        setProducts: function(data){
            this.products = data;
        }
    },

    onEdit(data) {
        //window.console.log("add edit" + data);
        this.form = data;
        this.form.isEdit = true;
    },
};
</script>

<style scoped>
.alert-warning {
    color: #856404 !important;
    background-color: #fff3cd !important;
    border-color: #ffeeba !important;
}
</style>